import { useEffect, useRef, useState } from "react";



const BannerSlider = ({ banners }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const intervalRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    if (isAutoPlaying && banners.length > 1) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % banners.length);
      }, 4000); 

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
    
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isAutoPlaying, banners.length]); 

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % banners.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const handleBannerClick = (link) => {
    if (link && link !== "#") {
      window.location.href = link;
    }
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setTouchEnd(0); 
    setIsAutoPlaying(false);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe && banners.length > 1) {
      goToNext();
    }
    if (isRightSwipe && banners.length > 1) {
      goToPrev();
    }

    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 100);
  };

  const handleMouseEnter = () => {
    setIsAutoPlaying(false);
  };

  const handleMouseLeave = () => {
    setIsAutoPlaying(true);
  };

  if (banners.length === 0) return null;

  return (
    <div className="mb-[2.5rem] md:mb-[3.75rem] flex justify-center px-[1rem] md:px-[2.5rem]">
      <div className="relative w-[calc(100vw-2rem)] max-w-[22.25rem] md:max-w-[34.375rem] min-w-[20rem]">
        <div
          ref={sliderRef}
          className="relative overflow-hidden rounded-[1.25rem] w-full h-[7.5rem] md:h-[10.25rem]"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className="flex h-full transition-transform duration-500 ease-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {banners.map((banner) => (
              <div
                key={banner.id}
                className="w-full h-full flex-shrink-0 relative cursor-pointer"
                onClick={() => handleBannerClick(banner.banner_link)}
              >
                <img
                  src={banner.banner_url}
                  alt={`배너 ${banner.banner_position}`}
                  className="w-full h-full object-cover"
                  draggable={false}
                />
              </div>
            ))}
          </div>

          {banners.length > 1 && (
            <div className="absolute bottom-[0.8rem] md:bottom-[1.25rem] right-[1.25rem] md:right-[1.75rem] bg-[#FFFFFF4D]/30 text-white text-[0.7rem] md:text-base px-[0.56rem] md:px-[0.875rem] rounded-[0.56rem] md:rounded-[0.75rem]">
              <span className="font-semibold">{currentIndex + 1}</span> / {banners.length}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BannerSlider;